import { render, staticRenderFns } from "./photoPage.vue?vue&type=template&id=28d100f5&scoped=true"
import script from "./photoPage.vue?vue&type=script&lang=js"
export * from "./photoPage.vue?vue&type=script&lang=js"
import style0 from "./photoPage.vue?vue&type=style&index=0&id=28d100f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d100f5",
  null
  
)

export default component.exports